<template>
  <b-tooltip :active="nTagsLeft > 0" type="is-dark">
    <template v-slot:content>
      {{ $t('compCoreMyTagList.tooltip') }}
      <my-tag v-for="(tag, index) in tags" :key="index" :tag="tag" />
    </template>
    <b-taglist v-if="tags.length > 0" :attached="nTagsLeft > 0">
      <my-tag v-for="(tag, index) in tags2Display" :key="index" :tag="tag" />
      <b-tag v-if="nTagsLeft > 0">
        <em>+{{ nTagsLeft }}</em>
      </b-tag>
    </b-taglist>
    <span v-else>-</span>
  </b-tooltip>
</template>

<script>
export default {
  name: 'MyTagList',
  props: {
    tags: {
      type: Array,
      default: function () {
        return []
      }
    },
    limit: {
      type: Number,
      default: 2
    }
  },
  components: {
    'my-tag': () => import('@/components/core/MyTag.vue')
  },
  computed: {
    tags2Display: function () {
      if (this.tags.length > this.limit) {
        return this.tags.slice(0, this.limit)
      } else {
        return this.tags
      }
    },
    nTagsLeft: function () {
      return this.tags.length - this.tags2Display.length
    }
  }
}
</script>
